import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { JOB_API } from "./apiRoutes";

const mutateDeleteNewsMedia = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${JOB_API}/${id}`);
};

const useDeleteNewsMediaMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteNewsMedia,
    ...queryParams,
  });

export default useDeleteNewsMediaMutation;
